import { render } from "./filter-color-wheel.vue?vue&type=template&id=7c1f54ec&scoped=true"
import script from "./filter-color-wheel.vue?vue&type=script&lang=js"
export * from "./filter-color-wheel.vue?vue&type=script&lang=js"

import "./filter-color-wheel.vue?vue&type=style&index=0&id=7c1f54ec&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1f54ec"]])

export default __exports__